module.exports = __webpack_public_path__ + "static/media/27.cf63c4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/27.png
// module id = 1466
// module chunks = 0